import { MapPin } from "@phosphor-icons/react";

/**
 * Static styled map placeholder. Shows service radius overlay and city pin.
 * Real Google Maps embed can be swapped in later by replacing this component.
 */
export default function StaticMap({
  city = "Greater Toronto Area",
  testId = "static-map",
}) {
  return (
    <div
      data-testid={testId}
      className="relative w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-sm border border-[#E2E8F0] bg-[#F8FAFC]"
    >
      {/* Stylized map grid */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, #E2E8F0 1px, transparent 1px), linear-gradient(to bottom, #E2E8F0 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
        aria-hidden
      />
      {/* Faux roads */}
      <div className="absolute inset-0" aria-hidden>
        <div className="absolute top-1/2 left-0 right-0 h-1.5 bg-[#CBD5E1]" />
        <div className="absolute left-1/2 top-0 bottom-0 w-1.5 bg-[#CBD5E1]" />
        <div className="absolute top-[30%] left-0 right-0 h-1 bg-[#D1D5DB]" />
        <div className="absolute top-[72%] left-0 right-0 h-1 bg-[#D1D5DB]" />
        <div className="absolute left-[28%] top-0 bottom-0 w-1 bg-[#D1D5DB]" />
        <div className="absolute left-[72%] top-0 bottom-0 w-1 bg-[#D1D5DB]" />
      </div>
      {/* Service radius circle */}
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[#FF6B00] bg-[#FF6B00]/10"
        style={{ width: "70%", height: "85%" }}
        aria-hidden
      />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#FF6B00]/40"
        style={{ width: "40%", height: "50%" }}
        aria-hidden
      />
      {/* Pin */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-full flex flex-col items-center">
        <div className="rounded-sm bg-[#1B2A4A] text-white px-3 py-1.5 font-bold text-xs md:text-sm font-display whitespace-nowrap shadow-lg">
          {city}
        </div>
        <MapPin
          size={40}
          weight="fill"
          className="text-[#FF6B00] drop-shadow-lg -mt-1"
        />
      </div>
      {/* Label */}
      <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-sm border border-[#E2E8F0] text-xs font-bold font-display text-[#1B2A4A] uppercase tracking-wider">
        Service Radius
      </div>
    </div>
  );
}
